import { Vault } from './vault';
import { Pagination } from './pagination';

class VaultsPagination {
  data: Vault[];

  pagination: Pagination;

  constructor(params?: VaultsPaginationType) {
    this.data = params?.data || [];
    this.pagination = params?.pagination || new Pagination();
  }
}

export { VaultsPagination };
